function jsSelectForeignInsuranceToggle()
{
    if ( $('.jsSelectForeignInsuranceToggler').find('option[value="foreign"]').is(':selected') )
    {
        $('#jsSelectForeignInsuranceWrapper').show();
        $('.jsSelectForeignInsuranceSelect').attr('required', true);
    }
    else
    {
        $('#jsSelectForeignInsuranceWrapper').hide();
        $('.jsSelectForeignInsuranceSelect').attr('required', false);
    }
}

$(function(){
    if ( $('.jsSelectForeignInsuranceToggler').length )
    {
        jsSelectForeignInsuranceToggle();
        $('.jsSelectForeignInsuranceToggler').change(function(){
            jsSelectForeignInsuranceToggle();
        });
    }
});